import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { users_by_role } from "./_helpers";

export const select_substitutes: Query<Ctx> = async (ctx, _params) => {
  return users_by_role(ctx, "substitute");
};
